import { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import useCountUp from '../../hooks/useCountUp';
import { personalInfo } from '../../data/portfolioData';
import { fadeUp } from '../../motion/variants';

const StatItem = ({ stat, active, index }) => {
  const display = useCountUp(stat.value, active);

  return (
    <motion.div
      variants={fadeUp}
      custom={index}
      className="bg-ant-bg-2 px-3 py-4 sm:py-5 text-center lg:text-left"
    >
      <div className="text-base sm:text-2xl font-semibold text-white tracking-tight">{display}</div>
      <div className="text-[9px] sm:text-[11px] font-mono tracking-wider uppercase text-white/30 mt-1 leading-tight">
        {stat.label}
      </div>
    </motion.div>
  );
};

const HeroStats = () => {
  const containerRef = useRef(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setActive(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <motion.div
      ref={containerRef}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: '-40px' }}
      variants={{
        hidden: {},
        visible: { transition: { staggerChildren: 0.08, delayChildren: 0.1 } },
      }}
      className="grid grid-cols-2 sm:grid-cols-4 gap-px bg-white/[0.06] rounded-2xl overflow-hidden border border-white/[0.06]"
    >
      {personalInfo.stats.map((stat, index) => (
        <StatItem key={stat.label} stat={stat} active={active} index={index} />
      ))}
    </motion.div>
  );
};

export default HeroStats;